import { z } from "zod";


const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);

export const ArquivoGenericoSchema = z.object({
  IdTabela: optionalNumber,
  TipoTabela: optionalNumber,

  IdArquivoGenerico1: optionalNumber, // Para saber se é update ou create
  NomeArquivo1: optionalString,
  Arquivo1: z.any().nullable().optional(), // Base64 ou File

  // --- SLOT 2 (Ordem = 2) ---
  IdArquivoGenerico2: optionalNumber,
  NomeArquivo2: optionalString,
  Arquivo2: z.any().nullable().optional(),

  // --- SLOT 3 (Ordem = 3) ---
  IdArquivoGenerico3: optionalNumber,
  NomeArquivo3: optionalString,
  Arquivo3: z.any().nullable().optional(),
});

export type ArquivoGenericoForm = z.infer<typeof ArquivoGenericoSchema>;